export default "__VITE_PUBLIC_ASSET__b0fa755d__"